import { loadAppAccount } from './load-app-account.js'
import { loadAppAccountTrackings } from './load-appaccount-trackings.js'
import { loadCurrenciesForAccount } from './load-currencies-for-account.js'
import { loadEntities } from './load-entities.js'

const appAccountData = {}

function resetData () {
  appAccountData.appAccountId = null
  appAccountData.appAccount = null
  appAccountData.userRights = null
  appAccountData.entities = null
  appAccountData.firstLedgerDate = null
  appAccountData.currenciesForAccount = null
}

resetData()

export const browserAppAccount = {
  load: async function (params) {
    const { appAccountId } = params

    if (!appAccountId) {
      resetData()
      return
    }

    appAccountData.appAccountId = appAccountId

    await loadData(params)
  },

  refreshEntities: async function () {
    await executeLoadEntities(appAccountData)
  },

  identifyUserRights,

  data: appAccountData
}

async function executeLoadEntities (appAccountData) {
  if (!appAccountData.appAccountId) return
  appAccountData.entities = null
  appAccountData.firstLedgerDate = null

  const loadedEntities = await loadEntities(appAccountData.appAccountId)
  appAccountData.entities = loadedEntities
  appAccountData.firstLedgerDate = computeFirstLedgerDate(loadedEntities)
}

async function loadData (params) {
  const { appAccountId } = params

  const promises = []

  if (!appAccountData.appAccount) {
    promises.push((async function () {
      const loadedAppAccount = await loadAppAccount(appAccountId)
      appAccountData.appAccount = loadedAppAccount
    })())
  }

  if (params.includeEntities && !appAccountData.entities) {
    promises.push((async function () {
      await executeLoadEntities(appAccountData)
    })())
  }

  if (params.includeCurrencies && !appAccountData.currenciesForAccount) {
    promises.push((async function () {
      const loadedCurrenciesForAccount = await loadCurrenciesForAccount(appAccountId)
      appAccountData.currenciesForAccount = loadedCurrenciesForAccount
    })())
  }

  if (params.includeTrackings && !appAccountData.trackings) {
    promises.push((async function () {
      const loadedTrackings = await loadAppAccountTrackings(appAccountId)
      appAccountData.trackings = loadedTrackings
    })())
  }

  await Promise.all(promises)
}

function computeFirstLedgerDate (entities) {
  return entities?.reduce(function (reducerMin, entity) {
    if (!reducerMin || entity.info.min_ledger_date < reducerMin) reducerMin = entity.info.min_ledger_date
    return reducerMin
  }, null)
}

function identifyUserRights (params) {
  // console.log('identifyUserRights', params)
  const { browserAppUser } = params
  if (!appAccountData.appAccount) return
  if (!browserAppUser) return

  const appUserId = browserAppUser.data.appUser.id
  // console.log('appUserId', appUserId)
  const userRights = appAccountData.appAccount.AppUserAccounts?.find(function (userAccount) {
    // console.log('userAccount', userAccount, userAccount.app_user_id, '===', appUserId)
    return userAccount.app_user_id === appUserId
  })?.rights
  appAccountData.userRights = userRights
}
